const link_list = {
    routePath: 'applications',
    actionName: 'pie-chart',
    iconClass: 'fa-solid fa-calendar-check',
    title: 'Open Application',
    search: '',
    sort: {
        order: 'asc',
        column: 'date_entered',
    },
    perPage: '',
}
export default {link_list }